module.exports = __webpack_public_path__ + "img/searchform.a42b1e73.svg";